import { PLAYER_LOADED, UPDATE_DURATION, UPDATE_POSITION } from "../reducers/actiontypes";

export let updateDuration = function(duration) {
	return {
		type: UPDATE_DURATION,
		duration: duration
	};
}

export let updatePosition = function(position) {
	return {
		type: UPDATE_POSITION,
		position: position
	};
}

var currentPlayer = null;
export let setPlayerLoaded = function(player) {
	return function(dispatch, getState) {
		var state = getState(),
			duration = state.player.duration;

		dispatch({
			type: PLAYER_LOADED
		});

		currentPlayer = player;

		if (duration === 0) {
			player.getDuration((d) => dispatch(updateDuration(d)));
		}

		player.onTime((event) => dispatch(updatePosition(event.position)));

		player.onSeek((event) => dispatch(updatePosition(event.offset)));
	}
}

export let seek = function(timestamp) {
	return function(dispatch, getState) {
		if (currentPlayer !== null) {
			window.scrollTo(0, 0);
			currentPlayer.seek(timestamp);
		}
	}
}